/* eslint-disable global-require */
module.exports = [...require('./Clear/i18n'), ...require('./Create/i18n'), ...require('./NoAccess/i18n'), ...require('./SelectAll/i18n'), 'components.lotslists.create.m9'];
